import React from 'react';
import { adjustments, photos } from '../data/content';
import { OfferLink } from './ui/OfferLink';
import { Eyebrow, Mark } from './ui/Section';
export function Coaches() {
  return <section className="bg-white px-4 py-14 md:py-20" data-id="element-41" data-mp="3ihorfv339l3q">
      <div className="mx-auto grid max-w-6xl items-center gap-10 lg:grid-cols-2" data-id="element-42" data-mp="3ijjfvjdkjvck">
        <OfferLink label="See the Complete Stretching System 2026 offer" data-id="element-43" data-mp="3dqgh8wtxpvpi">
          <img src={photos.coachGroup} alt="Coach adjusting a student's half split while a mixed-level group stretches" className="aspect-[4/3] w-full rounded-3xl object-cover shadow-xl transition-transform duration-300 ease-out group-hover:scale-[1.01]" data-id="element-44" data-mp="3ri3mvn9rogky" />
        </OfferLink>
        <div data-id="element-45" data-mp="dn6r5g137xp">
          <Eyebrow align="left" data-id="element-46" data-mp="cvcbxy63g90">Built for coaches</Eyebrow>
          <h2 className="font-display text-2xl font-black uppercase leading-tight text-charcoal md:text-4xl" data-id="element-47" data-mp="2729xz1a39bdd">
            Beginners and advanced students <Mark data-id="element-48" data-mp="225jgqamjs9qd">in the same class?</Mark>
          </h2>
          <p className="mt-5 text-base leading-relaxed text-charcoal/80" data-id="element-49" data-mp="2p59y07kp2txv">
            You don't need a different session for every person. Keep the same training goal and
            adjust:
          </p>
          <ul className="mt-4 flex flex-wrap gap-2" data-id="element-50" data-mp="2y4wymr5lnvpv">
            {adjustments.map(item => <li key={item} className="rounded-md bg-forest px-3 py-1.5 text-xs font-black uppercase tracking-wide text-ivory" data-id="element-51" data-mp="32w597qio1n4m">
                {item}
              </li>)}
          </ul>
          <p className="mt-6 font-display text-sm font-black uppercase tracking-wide text-forest" data-id="element-52" data-mp="3cw5xlqve6tfo">
            Designed for individual students and mixed-level groups.
          </p>
        </div>
      </div>
    </section>;
}